import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import equal from "fast-deep-equal/es6/react";
import Chart from "chart.js";
import { PdApiActions, pdApiActions } from "../../actions/pdApiActions";
import classes from "./Chart.module.scss";

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {
  option: Api.OptionsGetChartData;
  datasets: Api.SeriesDataset[];
  title?: string;
  height?: string;
  width?: string;
  legendLabelPadding?: number;
};

export type TranslationSummaryChartProps = DispatchProps & OwnProps;

type OwnState = {
  allSelected: boolean;
};

class TranslationSummaryChart extends React.Component<TranslationSummaryChartProps, OwnState> {
  public static defaultProps = {
    height: "425px",
    legendLabelPadding: 25
  };
  chartRef: React.RefObject<HTMLCanvasElement> = React.createRef<HTMLCanvasElement>();
  myChart?: Chart = undefined;

  state = {
    allSelected: true
  };

  componentDidMount() {
    this.buildChart();
  }

  shouldComponentUpdate(nextProps: TranslationSummaryChartProps) {
    return !equal(this.props.datasets, nextProps.datasets);
  }

  componentDidUpdate() {
    this.buildChart();
  }

  toggleSelection = () => {
    const chart = this.myChart;
    const allSelected = !this.state.allSelected;

    if (chart && chart.data && chart.data.datasets) {
      chart.data.datasets.forEach(dataset => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Object.keys(dataset._meta).forEach(metaKey => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          dataset._meta[metaKey].data.forEach(dataItem => {
            dataItem.hidden = !allSelected || null;
          });
        });
      });
      chart.update();
      this.setState({ allSelected });
    }
  };

  buildChart() {
    const { datasets, legendLabelPadding } = this.props;

    const myChartRef = this.chartRef.current?.getContext("2d");

    if (this.myChart) {
      this.myChart.destroy();
    }

    if (myChartRef) {
      this.myChart = new Chart(myChartRef, {
        type: "doughnut",
        data: {
          datasets: [
            {
              data: datasets.map(item => item.value),
              backgroundColor: ["#69C42D", "#C71F25"],
              borderWidth: 0
            }
          ],
          labels: datasets.map(item => item.label)
        },
        options: {
          events: ["mousemove", "mouseout", "touchstart", "touchmove"],
          maintainAspectRatio: false,

          animation: {
            duration: 500
          },
          legend: {
            display: true,
            position: "right",
            align: "center",

            labels: {
              padding: legendLabelPadding,
              boxWidth: 12
            }
          }
        }
      });
    }
  }

  render() {
    return (
      <div>
        <div className={classes.chartTitle}>{this.props.title}</div>
        <div className={classes.chartContainer}>
          <canvas
            id="translationSummaryChart"
            className={classes.translationSummaryChartCanvas}
            height={this.props.height}
            ref={this.chartRef}
          />
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch: Dispatch<PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(null, mapDispatchToProps)(TranslationSummaryChart);

